module.exports = __webpack_public_path__ + "img/icon5.4f0c4f30.png";